export * from './account-enabled-patch-form';
export * from './account-esistente';
export * from './account-resend-email-form';
export * from './account-segnalato';
export * from './actor';
export * from './actor-min-dto';
export * from './aggiornamento';
export * from './aggiornamento-payload';
export * from './aggregatore';
export * from './allegato-copiabile-dto';
export * from './allegato-dto';
export * from './allegato-da-copiare';
export * from './allegato-payload';
export * from './altro-caso-tariffario-dto';
export * from './ambito-regola-punteggio';
export * from './anagrafica-dto';
export * from './anteprima-contributo-dto';
export * from './articolo-item';
export * from './articolo-pratica-status';
export * from './assegnazione-articolo-cedola-attivo-patch-form';
export * from './assegnazione-articolo-cedola-creation-form';
export * from './assegnazione-articolo-cedola-dto';
export * from './assegnazione-articolo-cedola-list-filter';
export * from './assegnazione-articolo-cedola-patch-form';
export * from './assegnazione-articolo-cedola-with-chain-dto';
export * from './associa-comune-form';
export * from './associa-operatore-comune-form';
export * from './audit-chiamata-dto';
export * from './audit-chiamata-errori-export-dto';
export * from './audit-chiamata-list-filter';
export * from './authority-type';
export * from './autore';
export * from './azione-operatore-esercente-dto';
export * from './azione-stato';
export * from './azione-stato-dto';
export * from './bando-transazioni-select-dto';
export * from './binding-target';
export * from './binding-target-esercente';
export * from './bucket';
export * from './campo-mensa';
export * from './canale-comunicazione';
export * from './cancellazione';
export * from './capabilities-dto';
export * from './cassiere-backoffice-list-filter';
export * from './cassiere-backoffice-row-dto';
export * from './cassiere-creation-form';
export * from './cassiere-dto';
export * from './cassiere-negozi-replace-form';
export * from './categoria-dto';
export * from './categoria-dipendente-mensa';
export * from './categoria-form';
export * from './cella-tariffario-dto';
export * from './cittadino-assistenza-form';
export * from './cittadino-backoffice-row-dto';
export * from './cittadino-list-filter';
export * from './cittadino-mensa-studente-dto';
export * from './cittadino-registration-form';
export * from './cittadino-servizio-dto';
export * from './cittadino-servizio-mensa-configurazione-dto';
export * from './cittadino-sincronizzazione-keycloak-dto';
export * from './cittadino-tariffa-mensa-dto';
export * from './classe-sezione-form';
export * from './collegamento-esito-dto';
export * from './collegamento-stato-dto';
export * from './collegamento-token-form';
export * from './colonna-tariffario-dto';
export * from './componente-aggiunto-payload';
export * from './componente-nucleo-min-dto';
export * from './componente-rimosso-payload';
export * from './comune-admin-creation-form';
export * from './comune-admin-dto';
export * from './comune-admin-list-filter';
export * from './comune-admin-update-form';
export * from './comune-cittadino-list-filter';
export * from './comune-cittadino-min-dto';
export * from './comune-cittadino-summary-dto';
export * from './comune-compact-dto';
export * from './comune-compact-list-filter';
export * from './comune-esercente-list-filter';
export * from './comune-esercente-summary-dto';
export * from './comunicazione-email-avvio-dto';
export * from './comunicazione-email-dettaglio-dto';
export * from './comunicazione-email-esito-dto';
export * from './comunicazione-email-form';
export * from './comunicazione-email-invio-dto';
export * from './comunicazione-outbox-dto';
export * from './comunicazione-outbox-list-filter';
export * from './comunicazione-outbox-stato';
export * from './comunicazione-payload';
export * from './comunicazioni-count';
export * from './condizione-altro-caso-dto';
export * from './condizione-dto';
export * from './configurazione-form-cittadino-dto';
export * from './configurazione-form-template-dto';
export * from './configurazione-form-translate-response-dto';
export * from './configurazione-form-translated-dto';
export * from './configurazione-mail-dto';
export * from './configurazione-mail-form';
export * from './configurazione-mail-test-request';
export * from './configurazione-mail-validate-request';
export * from './configurazione-sms-dto';
export * from './configurazione-sms-form';
export * from './configurazione-sms-test-request';
export * from './configurazione-sms-validate-request';
export * from './configurazione-test-response';
export * from './contributo-fascia-dto';
export * from './contributo-fascia-form';
export * from './crea-tipo-pratica-da-template-request-dto';
export * from './criterio-spareggio';
export * from './criterio-spareggio-dto';
export * from './criterio-spareggio-form';
export * from './dashboard-dto';
export * from './dashboard-denaro-dto';
export * from './dashboard-esercenti-dto';
export * from './dashboard-filter';
export * from './dashboard-funnel-dto';
export * from './dashboard-mensa-dto';
export * from './dashboard-pratiche-dto';
export * from './dashboard-tempo-risposta-dto';
export * from './dashboard-trend-bucket-dto';
export * from './dashboard-trend-dto';
export * from './dashboard-trend-filter';
export * from './date-time-dto';
export * from './debito-mesi-precedenti';
export * from './depubblica-tipo-pratica-form';
export * from './destinatario-ricerca-dto';
export * from './difformita-studente';
export * from './direzione-ordinamento';
export * from './disattiva-otp-tipo-pratica-form';
export * from './documenti-accettazione-form';
export * from './documenti-clona-form';
export * from './documenti-da-accettare-dto';
export * from './documenti-ordine-form';
export * from './documento';
export * from './documento-admin-dto';
export * from './documento-bozza-form';
export * from './documento-bozza-spunta-form';
export * from './documento-cittadino-dto';
export * from './documento-cittadino-spunta-dto';
export * from './documento-convenzione-richiesto';
export * from './documento-correzione-form';
export * from './documento-correzione-spunta-form';
export * from './documento-correzione-storico-dto';
export * from './documento-spunta-dto';
export * from './documento-version-form';
export * from './documento-versione-dettaglio-dto';
export * from './documento-versione-sintesi-dto';
export * from './documento-vigente-dto';
export * from './economia-dto';
export * from './errore-client-export-dto';
export * from './errore-client-occorrenza-dto';
export * from './errore-client-occorrenza-list-filter';
export * from './errore-client-problema-dto';
export * from './errore-client-problema-list-filter';
export * from './errore-client-segnalazione-form';
export * from './esempio';
export * from './esercente-backoffice-list-filter';
export * from './esercente-backoffice-row-dto';
export * from './esercente-cancellazione-riepilogo-dto';
export * from './esercente-cassiere-stato-account-esito-dto';
export * from './esercente-comune-riferimento-dto';
export * from './esercente-count';
export * from './esercente-importazione-candidata-dto';
export * from './esercente-importazione-candidate-dto';
export * from './esercente-importazione-esito-dto';
export * from './esercente-importazione-form';
export * from './esercente-importazione-proposta-dto';
export * from './esercente-importazione-risultato-dto';
export * from './esercente-pratica-backoffice-row-dto';
export * from './esercente-profilo-creation-form';
export * from './esercente-profilo-list-filter';
export * from './esercente-profilo-row-dto';
export * from './esercente-profilo-scheda-dto';
export * from './esercente-profilo-update-form';
export * from './esercente-registration-form';
export * from './esiti-operazione-dto';
export * from './esito-importazione-esercente';
export * from './evento';
export * from './evento-comunicazione-configurabile-dto';
export * from './evento-tipo-pratica';
export * from './exception-response-dto';
export * from './exception-response-with-details-dto';
export * from './exception-response-with-residuo-dto';
export * from './exception-response-with-retry-after-dto';
export * from './exception-response-with-voucher-list-dto';
export * from './fascia-tariffario-dto';
export * from './field-change';
export * from './fonte-isee-tariffa';
export * from './fonte-predicato';
export * from './forma-proroga-voucher';
export * from './generic-response-dto';
export * from './get-profilo-servizio409-response';
export * from './get-profilo-servizio422-response';
export * from './giorno-della-settimana-enum';
export * from './graduatoria-anteprima-eligibilita-dto';
export * from './graduatoria-anteprima-eligibilita-form';
export * from './graduatoria-bilancio-dto';
export * from './graduatoria-canali-esito-dto';
export * from './graduatoria-comunicazione-summary-dto';
export * from './graduatoria-creation-form';
export * from './graduatoria-dto';
export * from './graduatoria-eligibilita-nodo-dto';
export * from './graduatoria-eligibilita-nodo-form';
export * from './graduatoria-list-item-dto';
export * from './graduatoria-residuo-dto';
export * from './graduatoria-ricalcolo-form';
export * from './graduatoria-riga-dto';
export * from './graduatoria-riga-pubblicazione-dto';
export * from './graduatoria-scorrimento-dto';
export * from './graduatoria-scorrimento-form';
export * from './graduatoria-scorrimento-piano-dto';
export * from './graduatoria-scorrimento-piano-riga-dto';
export * from './graduatoria-scorrimento-stato-dto';
export * from './graduatoria-snapshot-dto';
export * from './gruppo';
export * from './include-form';
export * from './info-personali-patch-form';
export * from './isee-cittadino-dto';
export * from './isee-cittadino-upsert-form';
export * from './istituti-count';
export * from './limite-assegnazione';
export * from './logica-join';
export * from './login-response';
export * from './mappa-pasto-scuola';
export * from './menu-non-ordinario-dto';
export * from './menu-non-ordinario-form';
export * from './mia-accettazione';
export * from './modalita-convenzione';
export * from './modalita-estensione';
export * from './modalita-mappa';
export * from './motivo-esclusione-importazione-esercente';
export * from './motivo-salto-importazione-esercente';
export * from './motivo-tariffa-cittadino';
export * from './motivo-tariffa-dto';
export * from './negozio-creation-form';
export * from './negozio-dto';
export * from './negozio-partecipante-dto';
export * from './negozio-patch-form';
export * from './negozio-pos-dto';
export * from './negozio-proposta';
export * from './negozio-transazioni-select-dto';
export * from './nota-payload';
export * from './notifica-push-broadcast-form';
export * from './notifica-push-destinatari-dto';
export * from './notifica-push-invio-dto';
export * from './notifica-push-selezione-form';
export * from './notifica-push-utente-form';
export * from './occorrenza';
export * from './operator-login-form';
export * from './operatore-comune-compact-dto';
export * from './operatore-comune-creation-form';
export * from './operatore-comune-dto';
export * from './operatore-comune-list-filter';
export * from './operatore-comune-update-form';
export * from './operatore-pratica-creation-form';
export * from './operatore-pratica-dto';
export * from './operatore-pratica-list-filter';
export * from './operatore-pratica-patch-form';
export * from './operatore-predicato';
export * from './operatore-servizio-mensa-compact-dto';
export * from './operatore-servizio-mensa-creation-form';
export * from './operatore-servizio-mensa-dto';
export * from './operatore-servizio-mensa-list-filter';
export * from './operatore-servizio-mensa-patch-form';
export * from './operatore-stato-accesso-dto';
export * from './operazione';
export * from './ordinamento-pari-punteggio';
export * from './ordinamento-scolastico';
export * from './origine-allegato';
export * from './origine-ricarica';
export * from './orphan-warning-dto';
export * from './otp-payload';
export * from './otp-verifica-form';
export * from './pagamenti';
export * from './page-metadata';
export * from './pageable';
export * from './paged-model-assegnazione-articolo-cedola-dto';
export * from './paged-model-assegnazione-articolo-cedola-with-chain-dto';
export * from './paged-model-audit-chiamata-dto';
export * from './paged-model-cassiere-backoffice-row-dto';
export * from './paged-model-cassiere-dto';
export * from './paged-model-cittadino-backoffice-row-dto';
export * from './paged-model-comune-admin-dto';
export * from './paged-model-comune-cittadino-summary-dto';
export * from './paged-model-comune-compact-dto';
export * from './paged-model-comune-esercente-summary-dto';
export * from './paged-model-comunicazione-email-invio-dto';
export * from './paged-model-comunicazione-outbox-dto';
export * from './paged-model-destinatario-ricerca-dto';
export * from './paged-model-errore-client-occorrenza-dto';
export * from './paged-model-errore-client-problema-dto';
export * from './paged-model-esercente-backoffice-row-dto';
export * from './paged-model-esercente-pratica-backoffice-row-dto';
export * from './paged-model-esercente-profilo-row-dto';
export * from './paged-model-graduatoria-riga-dto';
export * from './paged-model-graduatoria-scorrimento-dto';
export * from './paged-model-negozio-dto';
export * from './paged-model-notifica-push-invio-dto';
export * from './paged-model-operatore-comune-compact-dto';
export * from './paged-model-operatore-pratica-dto';
export * from './paged-model-operatore-servizio-mensa-compact-dto';
export * from './paged-model-pratica-cittadino-list-item-dto';
export * from './paged-model-pratica-esercente-detail-dto';
export * from './paged-model-pratica-esercente-evento-dto';
export * from './paged-model-pratica-esercente-nota-dto';
export * from './paged-model-pratica-esercente-summary-dto';
export * from './paged-model-pratica-evento-dto';
export * from './paged-model-pratica-nota-dto';
export * from './paged-model-pratica-operatore-detail-dto';
export * from './paged-model-pratica-operatore-list-item-dto';
export * from './paged-model-segnalazione-account-row-dto';
export * from './paged-model-servizio-list-item-dto';
export * from './paged-model-servizio-mensa-anagrafica-row-dto';
export * from './paged-model-servizio-mensa-rendicontazione-dto';
export * from './paged-model-servizio-mensa-rendicontazione-report-row-dto';
export * from './paged-model-servizio-mensa-report-dto';
export * from './paged-model-servizio-mensa-ricarica-dto';
export * from './paged-model-servizio-mensa-ricarica-report-row-dto';
export * from './paged-model-servizio-mensa-studente-dto';
export * from './paged-model-servizio-mensa-studente-report-dto';
export * from './paged-model-servizio-operatore-assegnazione-dto';
export * from './paged-model-tipo-pratica-attributo-dto';
export * from './paged-model-tipo-pratica-attributo-esercente-dto';
export * from './paged-model-tipo-pratica-attributo-esercente-valore-dto';
export * from './paged-model-tipo-pratica-attributo-valore-dto';
export * from './paged-model-tipo-pratica-cittadino-summary-dto';
export * from './paged-model-tipo-pratica-dto';
export * from './paged-model-tipo-pratica-documento-dto';
export * from './paged-model-tipo-pratica-esercente-summary-dto';
export * from './paged-model-tipo-pratica-evento-comunicazione-dto';
export * from './paged-model-tipo-pratica-istituto-dto';
export * from './paged-model-tipo-pratica-istituto-plesso-assegnazione-dto';
export * from './paged-model-tipo-pratica-istituto-plesso-dto';
export * from './paged-model-tipo-pratica-operatore-assegnazione-dto';
export * from './paged-model-tipo-pratica-operatore-dto';
export * from './paged-model-tipo-pratica-regola-punteggio-categoria-dto';
export * from './paged-model-tipo-pratica-regola-punteggio-dto';
export * from './paged-model-tipo-pratica-regola-punteggio-fascia-dto';
export * from './paged-model-tipo-pratica-regola-punteggio-predicato-dto';
export * from './paged-model-transazione-voucher-backoffice-list-item-dto';
export * from './paged-model-transazione-voucher-list-item-dto';
export * from './paged-model-user-compact-dto';
export * from './paged-model-voucher-cittadino-dto';
export * from './paged-model-voucher-esercente-dto';
export * from './pago-pa-config-dto';
export * from './pago-pa-config-form';
export * from './passkey-check-response';
export * from './passkey-device-info';
export * from './passkey-login-options-form';
export * from './passkey-login-options-response';
export * from './passkey-login-verify-form';
export * from './passkey-registration-options-response';
export * from './passkey-registration-verify-form';
export * from './passkey-status-response';
export * from './pasti-non-ordinari';
export * from './pasti-non-ordinari-specifici';
export * from './pasti-non-ordinari-studenti';
export * from './periodo-esenzione-tariffa-dto';
export * from './periodo-rendicontazione-creation-form';
export * from './periodo-rendicontazione-dto';
export * from './periodo-rendicontazione-status';
export * from './permessi-miei-dto';
export * from './permesso';
export * from './permesso-concesso-form';
export * from './permesso-utente-dto';
export * from './platform-action-type';
export * from './policy-dto';
export * from './portafogli';
export * from './pratica-allegato-dto';
export * from './pratica-allegato-operatore-creation-form';
export * from './pratica-anagrafica-update-form';
export * from './pratica-attributi-bulk-update-form';
export * from './pratica-cambio-stato-form';
export * from './pratica-cittadino-capabilities-dto';
export * from './pratica-cittadino-detail-dto';
export * from './pratica-cittadino-eligibilita-dto';
export * from './pratica-cittadino-esito-graduatoria-dto';
export * from './pratica-cittadino-list-filter';
export * from './pratica-cittadino-list-item-dto';
export * from './pratica-cittadino-otp-context-dto';
export * from './pratica-cittadino-scadenza-bando-dto';
export * from './pratica-cittadino-submit-form';
export * from './pratica-cittadino-timeline-item-dto';
export * from './pratica-codice-anpr-dto';
export * from './pratica-codice-anpr-update-form';
export * from './pratica-componente-create-form';
export * from './pratica-componente-update-form';
export * from './pratica-comunicazione-esito-dto';
export * from './pratica-conflitto-dto';
export * from './pratica-edit-session-snapshot-dto';
export * from './pratica-esercente-backoffice-list-filter';
export * from './pratica-esercente-counters-dto';
export * from './pratica-esercente-detail-dto';
export * from './pratica-esercente-eligibilita-dto';
export * from './pratica-esercente-evento-dto';
export * from './pratica-esercente-evento-list-filter';
export * from './pratica-esercente-export-zip-filter';
export * from './pratica-esercente-negozio-aggiungi-form';
export * from './pratica-esercente-nota-create-request';
export * from './pratica-esercente-nota-dto';
export * from './pratica-esercente-pdf-rigenera-dto';
export * from './pratica-esercente-per-conto-form';
export * from './pratica-esercente-self-list-filter';
export * from './pratica-esercente-stato-patch-form';
export * from './pratica-esercente-submit-form';
export * from './pratica-esercente-submit-response-dto';
export * from './pratica-esercente-summary-dto';
export * from './pratica-evento-dto';
export * from './pratica-evento-dto-payload';
export * from './pratica-evento-list-filter';
export * from './pratica-evento-payload';
export * from './pratica-export-tabular-filter';
export * from './pratica-export-zip-filter';
export * from './pratica-nota-create-request';
export * from './pratica-nota-dto';
export * from './pratica-operatore-detail-dto';
export * from './pratica-operatore-list-filter';
export * from './pratica-operatore-list-item-dto';
export * from './pratica-operatore-summary-dto';
export * from './pratica-pdf-rigenera-dto';
export * from './pratica-punteggio-override-form';
export * from './pratica-punteggio-ricalcola-form';
export * from './pratica-submit-anagrafica-part';
export * from './pratica-submit-componente-part';
export * from './pratica-submit-response-dto';
export * from './pratiche-cittadino-counters-dto';
export * from './pratiche-cittadino-counters-filter';
export * from './pratiche-operatore-counters-dto';
export * from './pratiche-operatore-counters-filter';
export * from './pratiche-operatore-stats-dto';
export * from './problema';
export * from './profilo-esercente-dto';
export * from './profilo-esercente-update-form';
export * from './profilo-studente-simulazione-form';
export * from './proposta-clone-dto';
export * from './push-token-upsert-form';
export * from './readiness-issue-dto';
export * from './readiness-report-dto';
export * from './refresh-token-form';
export * from './regola-dto';
export * from './regola-match-dto';
export * from './regole-punteggio-count';
export * from './rendicontazione-esercente-dto';
export * from './rendicontazione-esercente-status';
export * from './rendicontazione-negozio-dto';
export * from './rendicontazione-nota-form';
export * from './report-generazione-dovuti-dto';
export * from './requisito-dto';
export * from './requisito-stato';
export * from './resoconto-pasti-classe-sezione';
export * from './resoconto-pasti-dipendenti';
export * from './resoconto-pasti-studenti';
export * from './revoca-voucher-modalita';
export * from './riapri-tipo-pratica-form';
export * from './ricarica';
export * from './richiedente-compact-dto';
export * from './richiesta-pratica-esercente-status';
export * from './riepilogo-tariffa-dto';
export * from './riga-confine-modalita';
export * from './rilascio-budget-revoca';
export * from './ripristina-tipo-pratica-form';
export * from './scadenza-voucher-decorrenza';
export * from './scadenza-voucher-modalita';
export * from './scheda-tariffario-dto';
export * from './scoring-manual-override-payload';
export * from './scoring-override-dto';
export * from './scoring-payload';
export * from './scuola';
export * from './scuola-assegnata-item';
export * from './segnalante';
export * from './segnalazione-account-chiusura-form';
export * from './segnalazione-account-dto';
export * from './segnalazione-account-form';
export * from './segnalazione-account-inviata-dto';
export * from './segnalazione-account-list-filter';
export * from './segnalazione-account-nota-form';
export * from './segnalazione-account-presa-in-carico-form';
export * from './segnalazione-account-row-dto';
export * from './segnalazione-in-corso';
export * from './servizi-count';
export * from './servizi-list-filter';
export * from './servizio';
export * from './servizio-compact-dto';
export * from './servizio-creation-form';
export * from './servizio-dto';
export * from './servizio-da-template-form';
export * from './servizio-list-item-dto';
export * from './servizio-mensa-add-patch-ricarica-form';
export * from './servizio-mensa-allinea-scuole-dto';
export * from './servizio-mensa-anagrafica-iscrizione-dto';
export * from './servizio-mensa-anagrafica-row-dto';
export * from './servizio-mensa-anagrafiche-list-filter';
export * from './servizio-mensa-attributo-mapping-dto';
export * from './servizio-mensa-attributo-mapping-upsert-form';
export * from './servizio-mensa-calendario-mensa-dto';
export * from './servizio-mensa-calendario-scolastico-dto';
export * from './servizio-mensa-calendario-scolastico-form';
export * from './servizio-mensa-chiusura-scolastica-dto';
export * from './servizio-mensa-chiusura-scolastica-form';
export * from './servizio-mensa-chiusura-scolastica-update-form';
export * from './servizio-mensa-chiusure-scolastiche-bulk-form';
export * from './servizio-mensa-chiusure-settimanali-form';
export * from './servizio-mensa-comunicazione-destinatari-conteggio-dto';
export * from './servizio-mensa-comunicazione-email-form';
export * from './servizio-mensa-comunicazione-sms-form';
export * from './servizio-mensa-configurazione-dto';
export * from './servizio-mensa-dto';
export * from './servizio-mensa-difformita-pasti-dto';
export * from './servizio-mensa-dovuto-da-annullare-dto';
export * from './servizio-mensa-esenzione-form';
export * from './servizio-mensa-evento-aggiornamento-dto';
export * from './servizio-mensa-evento-calendario-dto';
export * from './servizio-mensa-evento-calendario-form';
export * from './servizio-mensa-evento-calendario-status';
export * from './servizio-mensa-evento-calendario-type';
export * from './servizio-mensa-fratello-dto';
export * from './servizio-mensa-genera-dovuto-form';
export * from './servizio-mensa-menu-dto';
export * from './servizio-mensa-menu-extra-form';
export * from './servizio-mensa-menu-type';
export * from './servizio-mensa-menu-upsert-form';
export * from './servizio-mensa-multiricarica-form';
export * from './servizio-mensa-orario-annullamento-form';
export * from './servizio-mensa-pasti-da-preparare-dto';
export * from './servizio-mensa-pasti-dipendenti-dto';
export * from './servizio-mensa-pasti-dipendenti-upsert-form';
export * from './servizio-mensa-payload';
export * from './servizio-mensa-rendicontazione-dto';
export * from './servizio-mensa-rendicontazione-report-row-dto';
export * from './servizio-mensa-rendicontazioni-list-filter';
export * from './servizio-mensa-report-dto';
export * from './servizio-mensa-report-intestazione-dto';
export * from './servizio-mensa-report-list-filter';
export * from './servizio-mensa-report-mensile-dto';
export * from './servizio-mensa-report-type';
export * from './servizio-mensa-ricarica-dto';
export * from './servizio-mensa-ricarica-detail-dto';
export * from './servizio-mensa-ricarica-report-row-dto';
export * from './servizio-mensa-ricarica-stato';
export * from './servizio-mensa-ricariche-list-filter';
export * from './servizio-mensa-ricariche-statistiche-dto';
export * from './servizio-mensa-ricariche-totali-dto';
export * from './servizio-mensa-saldi-iniziali-form';
export * from './servizio-mensa-saldo-iniziale-form';
export * from './servizio-mensa-scuola-dto';
export * from './servizio-mensa-sezione-classe-dto';
export * from './servizio-mensa-sospensione-form';
export * from './servizio-mensa-studente-aggiornamento-dto';
export * from './servizio-mensa-studente-anagrafica-dto';
export * from './servizio-mensa-studente-dto';
export * from './servizio-mensa-studente-discovery-dto';
export * from './servizio-mensa-studente-genitore';
export * from './servizio-mensa-studente-list-filter';
export * from './servizio-mensa-studente-portafogli-dto';
export * from './servizio-mensa-studente-report-dto';
export * from './servizio-mensa-studente-sospensione';
export * from './servizio-mensa-tariffa-dto';
export * from './servizio-mensa-template';
export * from './servizio-mensa-update-form';
export * from './servizio-mio-dto';
export * from './servizio-operatore-assegnazione-creation-form';
export * from './servizio-operatore-assegnazione-dto';
export * from './servizio-operatore-assegnazione-item';
export * from './servizio-operatore-assegnazione-patch-form';
export * from './servizio-operatore-scuole-dto';
export * from './servizio-operatore-scuole-replace-form';
export * from './servizio-operatori-bulk-replace-form';
export * from './servizio-operatori-list-filter';
export * from './servizio-update-form';
export * from './sesso';
export * from './spunta-valore';
export * from './stato-graduatoria';
export * from './stato-tariffa-cittadino';
export * from './storico-campo-dto';
export * from './storico-entry-dto';
export * from './storico-snapshot-dto';
export * from './storico-valore-a-data-dto';
export * from './summary-dto';
export * from './target-allegato';
export * from './target-attributo-definizione';
export * from './tariffa-mensa-condizione-form';
export * from './tariffa-mensa-dto';
export * from './tariffa-mensa-regola-form';
export * from './tariffa-mensa-simula-form';
export * from './tariffa-mensa-simulazione-dto';
export * from './tariffa-mensa-upsert-form';
export * from './tariffario-mensa-dto';
export * from './termini-accettazione-form';
export * from './termini-attivo-form';
export * from './termini-bozza-dto';
export * from './termini-bozza-form';
export * from './termini-pubblica-form';
export * from './termini-pubblico-admin-dto';
export * from './termini-stato-dto';
export * from './termini-versione-admin-dto';
export * from './termini-versione-dto';
export * from './termini-versione-dettaglio-dto';
export * from './tipo-calcolo-contributo';
export * from './tipo-conferma-pratica';
export * from './tipo-consumo-articolo';
export * from './tipo-convenzione';
export * from './tipo-file-sistema';
export * from './tipo-graduatoria';
export * from './tipo-nodo-eleggibilita';
export * from './tipo-pago-pa';
export * from './tipo-pratica-attributo-creation-form';
export * from './tipo-pratica-attributo-dto';
export * from './tipo-pratica-attributo-esercente-creation-form';
export * from './tipo-pratica-attributo-esercente-dto';
export * from './tipo-pratica-attributo-esercente-list-filter';
export * from './tipo-pratica-attributo-esercente-patch-form';
export * from './tipo-pratica-attributo-esercente-valore-creation-form';
export * from './tipo-pratica-attributo-esercente-valore-dto';
export * from './tipo-pratica-attributo-esercente-valore-patch-form';
export * from './tipo-pratica-attributo-list-filter';
export * from './tipo-pratica-attributo-patch-form';
export * from './tipo-pratica-attributo-valore-creation-form';
export * from './tipo-pratica-attributo-valore-dto';
export * from './tipo-pratica-attributo-valore-patch-form';
export * from './tipo-pratica-canale-comunicazione-dto';
export * from './tipo-pratica-canale-comunicazione-patch-form';
export * from './tipo-pratica-cittadino-list-filter';
export * from './tipo-pratica-cittadino-min-dto';
export * from './tipo-pratica-cittadino-stato-dto';
export * from './tipo-pratica-cittadino-summary-dto';
export * from './tipo-pratica-clone-form';
export * from './tipo-pratica-clone-response-dto';
export * from './tipo-pratica-clone-summary-dto';
export * from './tipo-pratica-creation-form';
export * from './tipo-pratica-dto';
export * from './tipo-pratica-documento-dto';
export * from './tipo-pratica-documento-patch-form';
export * from './tipo-pratica-esercente-list-filter';
export * from './tipo-pratica-esercente-summary-dto';
export * from './tipo-pratica-evento-comunicazione-creation-form';
export * from './tipo-pratica-evento-comunicazione-dto';
export * from './tipo-pratica-evento-comunicazione-list-filter';
export * from './tipo-pratica-graduatoria-form';
export * from './tipo-pratica-istituto-creation-form';
export * from './tipo-pratica-istituto-dto';
export * from './tipo-pratica-istituto-list-filter';
export * from './tipo-pratica-istituto-patch-form';
export * from './tipo-pratica-istituto-plesso-assegnazione-creation-form';
export * from './tipo-pratica-istituto-plesso-assegnazione-dto';
export * from './tipo-pratica-istituto-plesso-assegnazione-list-filter';
export * from './tipo-pratica-istituto-plesso-assegnazione-patch-form';
export * from './tipo-pratica-istituto-plesso-assegnazione-select-dto';
export * from './tipo-pratica-istituto-plesso-creation-form';
export * from './tipo-pratica-istituto-plesso-dto';
export * from './tipo-pratica-istituto-plesso-list-filter';
export * from './tipo-pratica-istituto-plesso-patch-form';
export * from './tipo-pratica-istituto-plesso-select-dto';
export * from './tipo-pratica-istituto-select-dto';
export * from './tipo-pratica-list-filter';
export * from './tipo-pratica-operatore-assegnazione-creation-form';
export * from './tipo-pratica-operatore-assegnazione-dto';
export * from './tipo-pratica-operatore-assegnazione-item';
export * from './tipo-pratica-operatore-capability-patch-form';
export * from './tipo-pratica-operatore-dto';
export * from './tipo-pratica-operatore-stato-dto';
export * from './tipo-pratica-operatori-bulk-replace-form';
export * from './tipo-pratica-patch-form';
export * from './tipo-pratica-policy-form';
export * from './tipo-pratica-regola-punteggio-categoria-creation-form';
export * from './tipo-pratica-regola-punteggio-categoria-dto';
export * from './tipo-pratica-regola-punteggio-categoria-patch-form';
export * from './tipo-pratica-regola-punteggio-creation-form';
export * from './tipo-pratica-regola-punteggio-dto';
export * from './tipo-pratica-regola-punteggio-fascia-creation-form';
export * from './tipo-pratica-regola-punteggio-fascia-dto';
export * from './tipo-pratica-regola-punteggio-fascia-patch-form';
export * from './tipo-pratica-regola-punteggio-list-filter';
export * from './tipo-pratica-regola-punteggio-patch-form';
export * from './tipo-pratica-regola-punteggio-predicato-creation-form';
export * from './tipo-pratica-regola-punteggio-predicato-dto';
export * from './tipo-pratica-regola-punteggio-predicato-list-filter';
export * from './tipo-pratica-regola-punteggio-predicato-patch-form';
export * from './tipo-pratica-stato';
export * from './tipo-pratica-stato-transition-form';
export * from './tipo-pratica-stato-transition-response-dto';
export * from './tipo-pratica-template';
export * from './tipo-transazione-voucher';
export * from './tipologia-comune';
export * from './tipologia-pratica';
export * from './transazione-voucher-articoli-batch-form';
export * from './transazione-voucher-articolo-errata-corrige-form';
export * from './transazione-voucher-articolo-spend-form';
export * from './transazione-voucher-backoffice-list-filter';
export * from './transazione-voucher-backoffice-list-item-dto';
export * from './transazione-voucher-errata-corrige-form';
export * from './transazione-voucher-list-filter';
export * from './transazione-voucher-list-item-dto';
export * from './transazione-voucher-spend-form';
export * from './transazione-voucher-spend-response-dto';
export * from './transazione-voucher-stats-dto';
export * from './transizione-payload';
export * from './translate-warning-dto';
export * from './ui-widget';
export * from './update-user-password-form';
export * from './user-compact-dto';
export * from './user-email-request';
export * from './user-profile-dto';
export * from './user-profile-update-form';
export * from './user-select-shortcut-filter';
export * from './validation-type';
export * from './valore';
export * from './valore-storico-dto';
export * from './visualizzazione-tipo-pratica';
export * from './voce-form';
export * from './voucher-articolo-dto';
export * from './voucher-articolo-riga-backoffice-dto';
export * from './voucher-check-preview-dto';
export * from './voucher-cittadino-bando-min-dto';
export * from './voucher-cittadino-dto';
export * from './voucher-cittadino-list-filter';
export * from './voucher-consegna-comunicazione-dto';
export * from './voucher-consegna-summary-dto';
export * from './voucher-dto';
export * from './voucher-disambiguazione-item-dto';
export * from './voucher-emissione-riga-fallita-dto';
export * from './voucher-emissione-summary-dto';
export * from './voucher-esercente-dto';
export * from './voucher-proroga-anteprima-dto';
export * from './voucher-proroga-bando-form';
export * from './voucher-proroga-dto';
export * from './voucher-proroga-esito-dto';
export * from './voucher-proroga-form';
export * from './voucher-revoca-annullamento-form';
export * from './voucher-revoca-dto';
export * from './voucher-revoca-form';
export * from './voucher-status';
export * from './warning-dto';
